import { render, staticRenderFns } from "./LostVideo.vue?vue&type=template&id=77e98a1b&scoped=true&"
import script from "./LostVideo.vue?vue&type=script&lang=js&"
export * from "./LostVideo.vue?vue&type=script&lang=js&"
import style0 from "./LostVideo.vue?vue&type=style&index=0&id=77e98a1b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e98a1b",
  null
  
)

export default component.exports